import React from 'react';
import { motion } from 'framer-motion';

const CampaignCardSkeleton = ({ index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.1 }}
      className="col-span-12 sm:col-span-6 xl:col-span-4 rounded-xl shadow-lg border-2 overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #2C3E50 0%, #34495E 100%)',
        borderColor: 'rgba(241, 196, 15, 0.3)',
        fontFamily: '"Share Tech Mono", monospace'
      }}
    >
      {/* Header */}
      <div className="p-6 pb-4">
        <div className="flex items-start justify-between mb-4">
          {/* Game Type Icon Skeleton */}
          <div className="flex items-center gap-3">
            <div 
              className="w-10 h-10 rounded-lg animate-pulse flex items-center justify-center"
              style={{ background: 'rgba(241, 196, 15, 0.2)' }}
            >
              <span className="text-lg">🎮</span>
            </div>
            <div>
              {/* Title Skeleton */}
              <div 
                className="h-5 w-32 rounded animate-pulse mb-2"
                style={{ background: 'rgba(241, 196, 15, 0.3)' }}
              />
              {/* Game Type Skeleton */}
              <div 
                className="h-3 w-20 rounded animate-pulse"
                style={{ background: 'rgba(241, 196, 15, 0.2)' }}
              />
            </div>
          </div>
          
          {/* Status Badge Skeleton */}
          <div 
            className="px-3 py-1 rounded-full text-xs font-bold animate-pulse"
            style={{ background: 'rgba(241, 196, 15, 0.2)' }}
          >
            <div className="w-12 h-3" style={{ background: 'rgba(241, 196, 15, 0.3)' }} />
          </div>
        </div>

        {/* Description Skeleton */}
        <div className="space-y-2 mb-4">
          <div 
            className="h-3 w-full rounded animate-pulse"
            style={{ background: 'rgba(241, 196, 15, 0.2)' }}
          />
          <div 
            className="h-3 w-3/4 rounded animate-pulse"
            style={{ background: 'rgba(241, 196, 15, 0.2)' }}
          />
        </div>

        {/* Stats Section Skeleton */}
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div className="text-center">
            <div 
              className="h-6 w-12 mx-auto rounded animate-pulse mb-1"
              style={{ background: 'rgba(241, 196, 15, 0.3)' }}
            />
            <div 
              className="h-3 w-16 mx-auto rounded animate-pulse"
              style={{ background: 'rgba(241, 196, 15, 0.2)' }}
            />
          </div>
          <div className="text-center">
            <div 
              className="h-6 w-12 mx-auto rounded animate-pulse mb-1"
              style={{ background: 'rgba(241, 196, 15, 0.3)' }}
            />
            <div 
              className="h-3 w-16 mx-auto rounded animate-pulse"
              style={{ background: 'rgba(241, 196, 15, 0.2)' }}
            />
          </div>
        </div>

        {/* Date Skeleton */}
        <div 
          className="h-3 w-24 rounded animate-pulse"
          style={{ background: 'rgba(149, 165, 166, 0.3)' }}
        />
      </div>

      {/* Footer Button Skeleton */}
      <div 
        className="px-6 py-4 border-t"
        style={{ borderColor: 'rgba(241, 196, 15, 0.2)' }}
      >
        <div 
          className="h-10 w-full rounded-lg animate-pulse"
          style={{ background: 'rgba(241, 196, 15, 0.2)' }}
        />
      </div>
    </motion.div>
  );
};

const CampaignsSkeleton = ({ count = 6 }) => {
  return (
    <div className="max-w-7xl mx-auto" style={{ fontFamily: '"Share Tech Mono", monospace' }}>
      {/* Header Skeleton */}
      <div className="mb-8 flex justify-between items-center">
        <div>
          <div 
            className="h-10 w-48 rounded animate-pulse mb-3"
            style={{ background: 'rgba(241, 196, 15, 0.3)' }}
          />
          <div 
            className="h-4 w-64 rounded animate-pulse"
            style={{ background: 'rgba(241, 196, 15, 0.2)' }}
          />
        </div>
        
        <div className="flex items-center gap-3">
          {/* Filter Button Skeleton */}
          <div 
            className="h-10 w-20 rounded animate-pulse"
            style={{ background: 'rgba(241, 196, 15, 0.2)' }}
          />
          {/* Create Button Skeleton */}
          <div 
            className="h-10 w-36 rounded animate-pulse"
            style={{ background: 'rgba(231, 76, 60, 0.3)' }}
          />
        </div>
      </div>

      {/* Campaign Cards Grid Skeleton */}
      <div className="grid grid-cols-12 gap-6">
        {Array.from({ length: count }, (_, index) => (
          <CampaignCardSkeleton key={index} index={index} />
        ))}
      </div>
    </div>
  );
};

export default CampaignsSkeleton; 